import React from 'react';
import { Box, Heading, Text, Button, VStack } from '@chakra-ui/react';

/**
 * Error fallback component displayed when an unhandled error occurs.
 * Integrated with Sentry ErrorBoundary for error tracking.
 */
const ErrorFallback = ({ error, componentStack, resetError }) => {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bg="gray.50"
      px={4}
    >
      <VStack
        spacing={6}
        maxW="500px"
        bg="white"
        p={8}
        borderRadius="lg"
        boxShadow="xl"
        textAlign="center"
      >
        <Heading size="xl" color="red.500">
          Oops! Something went wrong
        </Heading>

        <Text color="gray.600" fontSize="lg">
          We're sorry, but something unexpected happened. Our team has been notified and we're working on fixing it.
        </Text>

        {error && process.env.NODE_ENV === 'development' && (
          <Box
            w="100%"
            p={4}
            bg="red.50"
            borderRadius="md"
            borderLeft="4px solid"
            borderColor="red.500"
            textAlign="left"
          >
            <Text fontWeight="bold" color="red.700" mb={2}>
              Error Details (Development Only):
            </Text>
            <Text fontSize="sm" color="red.600" fontFamily="mono">
              {error.toString()}
            </Text>
          </Box>
        )}

        <Button
          colorScheme="blue"
          size="lg"
          onClick={handleReload}
          w="100%"
        >
          Reload Page
        </Button>
      </VStack>
    </Box>
  );
};

export default ErrorFallback;
